// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1s3Pe","top":"styles_top__1VMt3","left":"styles_left__2nHqh","description":"styles_description__3cOQq"};